function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React from 'react';
import { AppLink } from '@finect/tabular-core/AppLink';
import { getFundsListPath } from '@finect/front-resources/Products';
import { useTheme } from 'styled-components';
import { StyledTable, StyledTr, StyledTh, StyledTd } from '../../../Table';
import { EntityCard } from '../../../EntityCard';
import { AssetsLabel } from '../../Labels';
import { Tooltip } from '../../../Tooltip';
import { ManagementCompany } from '../../ManagementCompanies/ManagementCompany';
import { Inner } from './partials';
var TableView = function TableView(_ref) {
  var managementCompanies = _ref.managementCompanies,
    productType = _ref.productType;
  var theme = useTheme();
  return React.createElement(Inner, null, React.createElement(StyledTable, null, React.createElement("thead", null, React.createElement("tr", null, React.createElement(StyledTh, {
    left: true
  }, "Gestora"), React.createElement(StyledTh, {
    right: true
  }, React.createElement(Tooltip, {
    tip: React.createElement("div", null, "Patrimonio gestionado en ", React.createElement("br", null), " miles de millones", React.createElement("br", null), " de euros"),
    width: "200px",
    textAlign: "center",
    breakWord: true
  }, "Patrimonio gestionado")), React.createElement(StyledTh, {
    right: true
  }, productType.shortPlural), React.createElement(StyledTh, {
    right: true
  }, "Clases"))), React.createElement("tbody", null, managementCompanies.map(function (company) {
    return React.createElement(StyledTr, {
      key: company.id
    }, React.createElement(StyledTd, {
      left: true
    }, company.organization ? React.createElement(EntityCard, {
      type: "profile",
      entity: _objectSpread(_objectSpread({}, company.organization), {}, {
        name: company.name
      })
    }, React.createElement(ManagementCompany, {
      managementCompany: company,
      variant: "link",
      productType: productType
    })) : React.createElement(ManagementCompany, {
      managementCompany: company,
      variant: "link",
      productType: productType
    })), React.createElement(StyledTd, {
      right: true
    }, React.createElement(AssetsLabel, {
      value: company.stats.assets,
      scale: "milliard",
      currency: "\u20AC"
    })), React.createElement(StyledTd, {
      bold: true,
      right: true
    }, React.createElement(AppLink, {
      href: getFundsListPath(theme, productType, {
        company: company.id
      }),
      title: "Ver todos los ".concat(productType.plural, " de la gestora ").concat(company.name)
    }, company.stats.funds)), React.createElement(StyledTd, {
      right: true
    }, company.stats.classes));
  }))));
};
export default TableView;